import { jsxs as f, jsx as e } from "react/jsx-runtime";
import { memo as M, useState as N, useRef as j, useEffect as R } from "react";
import { useCreditUtils as T } from "@perxis-auto/credit-sdk";
import { useMatchMedia as w, BreakPointsEnum as z } from "@perxis-auto/shared";
import { Form as p, Row as o, Col as l, Typography as x, Input as E, Button as b, Icon as g, Slider as P } from "@perxis-auto/ui-kit";
const { useWatch: X, useFormInstance: L } = p, H = M(function({
  label: v,
  formatters: t,
  inputField: I,
  sliderField: u,
  sliderFieldProps: S,
  disabled: d
}) {
  var y;
  const [n, k] = N(!1), m = w(z.xsMax), s = j(null), h = L(), i = X(u, h), {
    formatters: { paymentTipFormatter: V, paymentValueFormatter: r }
  } = T({ form: h });
  R(() => {
    n && s.current && s.current.focus();
  }, [n, m]);
  const c = () => {
    k((a) => !a);
  }, B = i < 7, C = i >= 93, F = {
    0: B ? void 0 : { style: { transform: "translateX(0)" }, label: "0%" },
    100: C ? void 0 : { style: { transform: "translateX(-100%)" }, label: "100%" }
  };
  return /* @__PURE__ */ f(o, { className: "perxis-auto-credit-calc-slider", gutter: [0, "vertical-purple"], children: [
    /* @__PURE__ */ e(l, { span: 24, children: /* @__PURE__ */ f(o, { justify: "space-between", align: "middle", gutter: [0, "vertical-purple"], children: [
      (!m || !n) && /* @__PURE__ */ e(l, { children: /* @__PURE__ */ e(x.Text, { className: "perxis-auto-credit-calc-slider-label", level: "main", children: v }) }),
      n && /* @__PURE__ */ e(l, { xs: { span: 24 }, sm: { span: 12 }, children: /* @__PURE__ */ e(p.Item, { name: I, children: /* @__PURE__ */ e(
        E,
        {
          ref: s,
          onBlur: c,
          disabled: d,
          placeholder: t != null && t.payment ? t.payment(r(i)) : (y = r(i)) == null ? void 0 : y.toString(),
          suffix: /* @__PURE__ */ e(b, { type: "text", onClick: c, icon: /* @__PURE__ */ e(g, { size: 18, name: "check" }) })
        }
      ) }) }),
      !n && typeof i == "number" && /* @__PURE__ */ e(l, { children: /* @__PURE__ */ e(o, { justify: "end", children: /* @__PURE__ */ e(
        b,
        {
          className: "perxis-auto-credit-calc-slider-button-value",
          type: "text",
          onClick: c,
          icon: /* @__PURE__ */ e(g, { size: 18, name: "pen" }),
          children: /* @__PURE__ */ e(x.Text, { className: "perxis-auto-credit-calc-slider-value", level: "h4", children: t != null && t.payment ? t.payment(r(i)) : r(i) })
        }
      ) }) })
    ] }) }),
    /* @__PURE__ */ e(l, { span: 24, children: /* @__PURE__ */ e(p.Item, { name: u, ...S, children: /* @__PURE__ */ e(
      P,
      {
        min: 0,
        max: 100,
        valueVisible: !1,
        marks: F,
        disabled: d,
        tooltip: {
          open: !0,
          placement: "bottom",
          formatter: V,
          getPopupContainer: (a) => a.parentNode
        }
      }
    ) }) })
  ] });
});
export {
  H as SliderField
};
